import { render, staticRenderFns } from "./person-list.vue?vue&type=template&id=c3535638&lang=pug&"
import script from "./person-list.vue?vue&type=script&lang=js&"
export * from "./person-list.vue?vue&type=script&lang=js&"
import style0 from "./person-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports